import { gql } from '@apollo/client';

export const CREATE_BUSINESS = gql`
  mutation CreateBusiness($input: BusinessInput!) {
    createBusiness(input: $input) {
      id
      companyName
      sector
      logo
      contactName
      contactLastName
      contactPhone
      contactPosition
      address
      city
      country
      email
      website
      description
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_BUSINESS = gql`
  mutation UpdateBusiness($id: Int!, $input: BusinessInput!) {
    updateBusiness(id: $id, input: $input) {
      id
      companyName
      sector
      contactName
      contactLastName
      contactPhone
      contactPosition
      email
      address
      city
      country
      website
      description
      logo
      isActive
    }
  }
`;

export const DELETE_BUSINESS = gql`
  mutation DeleteBusiness($id: Int!) {
    deleteBusiness(id: $id) {
      id
    }
  }
`;

export const ACCEPT_BUSINESS_OFFER = gql`
  mutation AcceptBusinessOffer(
    $offerId: Int!
    $rooms: [RoomInput!]!
    $clients: [ClientInput!]!
    $assignments: [RoomAssignmentInput!]!
  ) {
    acceptBusinessOffer(
      offerId: $offerId
      rooms: $rooms
      clients: $clients
      assignments: $assignments
    ) {
      id
      status
      validUntil
      createdAt
    }
  }
`;

export const CREATE_BUSINESS_OFFER = gql`
  mutation CreateBusinessOffer($input: BusinessOfferInput!) {
    createBusinessOffer(input: $input) {
      id
      title
      description
      validUntil
      discount
      minimumParticipants
      status
    }
  }
`; 